import { SUPPORTED_LANGUAGES } from 'src/vars';

export const clearSearchParam = (param) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(param);

    const newUrl = `${window.location.pathname}?${searchParams}`;

    window.history.replaceState({}, '', newUrl);
};

export const isLocalURL = (url) => {
    try {
        // base allows relative inputs without throwing
        const u = new URL(url, 'http://example.org');
        const host = u.hostname;

        if (!host) return false;

        const isLoopback = host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host.startsWith('127.');

        const isDotLocal = host.endsWith('.local');

        return isLoopback || isDotLocal;
    } catch {
        return false;
    }
};

export const extractAndValidateIDFromURL = (url) => {
    let stripped = url;

    if (stripped.startsWith('https://')) {
        stripped = stripped.replace(/^https:\/\//i, '');
    } else if (stripped.startsWith('http://')) {
        stripped = stripped.replace(/^http:\/\//i, 'http:');
    }

    return `external-${encodeURIComponent(stripped)}`;
};

export function addQueryParam(url, key, value) {
    if (!url || !key) return url;
    const glue = /\?/.test(url) ? '&' : '?';
    const val = value ? `=${value}` : '';
    return [url, glue, key, val].join('');
}

export function addQueryParams(url, params) {
    return Object.keys(params).reduce((u, key) => (
        addQueryParam(u, key, params[key])
    ), url);
}

export const isTimeExperimentEnabled = () => {
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.get('texp') === '1';
};

export const isAssetsExperimentEnabled = () => {
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.get('aexp') === '1';
};

export const isMuteExperimentEnabled = () => {
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.get('mexp') === '1';
};

export const isLoaderExperimentEnabled = () => {
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.get('lexp') === '1';
};

export const getGameForwardParams = () => {
    const searchParams = new URLSearchParams(window.location.search);

    const gameForwardParams = {};

    const language = searchParams.get('iso_lang')?.toLowerCase();

    if (SUPPORTED_LANGUAGES.includes(language)) {
        gameForwardParams.iso_lang = language;
    }

    new URLSearchParams(searchParams)
        .forEach((value, key) => {
            if (key.toLowerCase().startsWith('gd')) {
                gameForwardParams[key] = value;
            }
        });

    const injects = [];

    if (isTimeExperimentEnabled()) {
        injects.push('time');
    }
    if (isAssetsExperimentEnabled()) {
        injects.push('assets');
    }
    if (isMuteExperimentEnabled()) {
        injects.push('mute');
    }
    if (isLoaderExperimentEnabled()) {
        injects.push('loader');
    }

    if (injects.length > 0) {
        gameForwardParams.inject = injects.join(',');
    }

    return gameForwardParams;
};
